<template>
  <div class="media">
   <PlayVideo/>
  </div>
</template>

<script>
import PlayVideo from '@/components/PlayVideo.vue'
export default {
    name: 'MediaTool',
    components: {
        PlayVideo
    },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .media{
    height:100%;
    width:100%;
    display:flex;
    justify-content: center;
    align-items: center;
  }
</style>
